import { DispatchReduxFetch } from '~/hooks/initializeData';

export const requiredReduxData = {
  HomePageSettings: [
    DispatchReduxFetch.Languages,
    DispatchReduxFetch.CustomAppearance,
  ],
  PortalBrandingSettings: [DispatchReduxFetch.CustomAppearance],
  WorkflowsConfigurationView: [
    DispatchReduxFetch.ApplicationConfig,
    DispatchReduxFetch.AllEnums,
    DispatchReduxFetch.Languages,
    DispatchReduxFetch.AllOrgUnits,
  ],
  CustomTranslationList: [
    DispatchReduxFetch.CustomTranslations,
    DispatchReduxFetch.Languages,
  ],
};
